<div class="app-component" appTheme>
	<router-outlet></router-outlet>
</div>
